import { useEffect, useRef, useState } from "react";
import { Button, Checkbox, Input, message, Table, Spin } from "antd";
import { hasSubstring } from "../../extensions/helper";
import { serverFetch } from "../../server";
import { isMobile, menuSize } from "../../extensions/design";
import Company from "./company";
import CompanyItem from "./company-item";
import "./companies.css";

const CompaniesList = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [filter, setFilter] = useState({ showHidden: false, serchText: "", vid: null });
  const divRef = useRef(null);

  const getData = () => {
    setLoading(true);
    serverFetch("company")
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, []);

  const formatTime = (value) => {
    if (!value) {
      return "";
    }

    const match = String(value).match(/T(\d{2}):(\d{2}):(\d{2})/);
    if (!match) {
      return String(value);
    }

    const [, hour, minute, second] = match;
    return `${hour}:${minute}:${second}`;
  };

  const columns = [
    {title: "Акт.", dataIndex: "active", render: value => <Checkbox checked={value} />, width: 50},
    {title: "#", dataIndex: "id"},
    {title: "Наименование", dataIndex: "name"},
    {title: "Email", dataIndex: "email"},
    {title: "Домен", dataIndex: "domain"},
    {title: "Комиссия, %", dataIndex: "prcComission", align: "right"},
    {title: "Комиссия по договору, %", dataIndex: "paymentPrc", align: "right"},
    {title: "Включена", dataIndex: "comissionIncluded", render: value => <Checkbox checked={value} />, width: 100},
    {title: "GMT", dataIndex: "gmt", align: "right" },
    {title: "Время", dataIndex: "companyTime", align: "right", render: value => formatTime(value) }
  ]

  const onClose = (refresh) => {
    setEditId();
    refresh && getData();
  }

  const divItem = editId != null && <Company id={editId} onClose={onClose} />
  const headerSize =  divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY) : 0;
  const tableWidth = (document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left) || 0;

  const onChangeFilter = value => setFilter({ ...filter, ...value });

  const filtered = items.filter(item => {
    if (!filter.showHidden && !item.active) return false;
    if (!hasSubstring(filter.serchText, item.name)) return false;
    return true;
  })

  const divTools = (
    <div className="sport-form-title">
      <Checkbox checked={filter.showHidden} onChange={e => onChangeFilter({ showHidden: e.target.checked })}>
        Показывать неактивные
      </Checkbox>
      <Input 
        placeholder="Поиск" 
        value={filter.serchText} 
        onChange={e => onChangeFilter({serchText: e.target.value})} 
        allowClear 
        style={isMobile ? {flex: 1} : {maxWidth: 200}}
      />
      <Button onClick={getData}>Обновить</Button>
    </div>
  );

  const divTable = isMobile ? (
    <div 
      className="company-items" 
      style={{
        height: window.innerHeight - menuSize, 
        overflowY: "scroll", 
        overflowX: "clip"
      }}
    >
      {loading ? (
        <div style={{textAlign: 'center', padding: '20px'}}>
          <Spin />
        </div>
      ) : (
        filtered.map(item => (
          <CompanyItem 
            key={item.id} 
            item={item} 
            onClick={() => setEditId(item.id)}
            isSelected={editId === item.id}
          />
        ))
      )}
    </div>
  ) : (
    <div ref={divRef} style={{width: tableWidth}}>
      <Table
        dataSource={filtered}
        columns={columns}
        rowKey="id"
        loading={loading}
        size="small"
        pagination={false}
        scroll={{ y: tableHeight }}
        rowSelection={{ type: 'radio', selectedRowKeys: [editId], renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
        onRow={(record) => ({onClick: () => {setEditId(record.id)}})}
      /> 
    </div>
  );

  return (
    <div className="sport-form-content" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {divTools}
      {divTable}
      {divItem}
    </div>
  );
}

export default CompaniesList;
